import h from 'hyperscript';
import {lory} from 'lory.js';
import {BREAKPOINTS} from '../../../javascripts/constants';

class Carousel {
  constructor($el) {

    this.options = {
      selectors: {
        navigation: '.carousel__navigation',
        navigationItem: 'li.carousel__navigation-item',
        items: '.carousel__item',
        pause: '.carousel__pause',
      },

      loryConfig: {
        classNameFrame: 'carousel__item-container',
        classNameSlideContainer: 'carousel__item-list',
        classNamePrevCtrl: 'carousel__prev',
        classNameNextCtrl: 'carousel__next',
      },

      maxSlidesPerPage: parseInt($el.dataset.maxSlidesPerPage, 10),
      slideshowConfig: false,
    };

    if ($el.dataset.slideshowSpeed) {
      this.options.slideshowConfig = {
        speed: parseInt($el.dataset.slideshowSpeed, 10),
        autoplay: true,
      };
    }

    this.$el = $el;
    this.$carouselItems = this.$el.querySelectorAll(this.options.selectors.items);
    this.$navigation = this.$el.querySelector(this.options.selectors.navigation);
    this.$navigationItem = h(this.options.selectors.navigationItem);
    this.$navigationArrows = [
      h(this.options.loryConfig.classNamePrevCtrl),
      h(this.options.loryConfig.classNameNextCtrl),
    ];
    this.$pause = this.$el.querySelector(this.options.selectors.pause);

    this.initCarousel();
  }

  loryConfig() {
    this.CAROUSEL_CONFIG = Object.assign(
      this.options.loryConfig, {
        infinite: this.numberOfVisibleItems(),
        slidesToScroll: 1,
      },
    );

    return this.CAROUSEL_CONFIG;
  }

  initCarousel() {
    this.initMediaQueries();
    this.initLory();
    this.initSlideshow();
  }

  initMediaQueries() {
    this.navigationMediaQuerySmall = window.matchMedia(`(max-width: ${BREAKPOINTS.m}) and (max-width: ${BREAKPOINTS.l})`);
    this.navigationMediaQuerySmall.addListener(this.reset.bind(this));

    this.navigationMediaQueryMedium = window.matchMedia(`(min-width: ${BREAKPOINTS.m}) and (max-width: ${BREAKPOINTS.l})`);
    this.navigationMediaQueryMedium.addListener(this.reset.bind(this));

    this.navigationMediaQueryLarge = window.matchMedia(`(min-width: ${BREAKPOINTS.l})`);
    this.navigationMediaQueryLarge.addListener(this.reset.bind(this));
  }

  initLory(config = this.loryConfig()) {
    this.$el.addEventListener('before.lory.init', this.handleDotEvent.bind(this));
    this.$el.addEventListener('after.lory.init', this.handleDotEvent.bind(this));
    this.$el.addEventListener('after.lory.slide', this.handleDotEvent.bind(this));

    this.$el.addEventListener('before.lory.init', this.handleTabindex.bind(this));
    this.$el.addEventListener('after.lory.init', this.handleTabindex.bind(this));
    this.$el.addEventListener('after.lory.slide', this.handleTabindex.bind(this));

    this.$el.addEventListener('on.lory.resize', this.handleDotEvent.bind(this));

    this.$slider = lory(this.$el, config);
  }

  initSlideshow() {
    if (this.options.slideshowConfig) {
      this.startSlideshow();

      this.$pause.addEventListener('click', e => this.toggleSlideshow(e));
    }

    this.$el.querySelectorAll('.carousel__control').forEach(($control) => {
      $control.addEventListener('keydown', (e) => {
        if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
          $control.click();
        }
      });
    });
  }

  startSlideshow() {
    this.slideshowTimer = setInterval(() => {
      this.$slider.next();
    }, this.options.slideshowConfig.speed);
  }

  stopSlideshow() {
    clearInterval(this.slideshowTimer);
  }

  toggleSlideshow(e) {
    this.options.slideshowConfig.autoplay = !this.options.slideshowConfig.autoplay;

    if (this.options.slideshowConfig.autoplay) {
      e.target.classList.remove('carousel__pause--active');

      this.startSlideshow();
    } else {
      e.target.classList.add('carousel__pause--active');

      this.stopSlideshow();
    }
  }

  handleTabindex(e) {
    // set tabindex to -1 for all elements previous the active element to prevent "hidden" tabbing
    const $items = this.$el.querySelectorAll('.carousel__item');

    let active = false;
    for (let i = 0; i < $items.length; i += 1) {
      const focusableEls = $items[i].querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');

      $items[i].removeAttribute('tabindex');

      for (let j = 0; j < focusableEls.length; j += 1) {
        focusableEls[j].removeAttribute('tabindex');
      }

      if ($items[i].classList.contains('active')) {
        active = true;
      }

      if (!active) {
        for (let j = 0; j < focusableEls.length; j += 1) {
          focusableEls[j].setAttribute('tabindex', '-1');
        }

        $items[i].setAttribute('tabindex', -1);
      }
    }


  }

  handleDotEvent(e) {
    if (e.type === 'before.lory.init') this.initDotNavigation();
    if (e.type === 'after.lory.init') this.bindDotNavigationEvents();
    if (e.type === 'after.lory.slide') this.updateDotNavigation(e);
    if (e.type === 'on.lory.resize') this.resetDotNavigation();
  }

  initDotNavigation() {
    this.$navigation.innerHTML = '';

    for (let i = 0, len = this.numberOfSlides(); i < len; i += 1) {
      const clone = this.$navigationItem.cloneNode();
      this.$navigation.appendChild(clone);
    }

    this.$navigation.childNodes[0].classList.add('active');
  }

  bindDotNavigationEvents() {
    for (let i = 0, len = this.numberOfSlides(); i < len; i += 1) {
      this.$navigation.childNodes[i].addEventListener('click', (event) => {
        const targetIndex = Array.prototype.indexOf.call(this.$navigation.childNodes, event.target);

        this.$slider.slideTo(
          targetIndex * this.numberOfVisibleItems(),
        );
      });
    }
    this.shouldNavigationBeHidden();
  }

  updateDotNavigation(e) {
    for (let i = 0, len = this.$navigation.childNodes.length; i < len; i += 1) {
      this.$navigation.childNodes[i].classList.remove('active');
    }

    const childNodeIndex = this.numberOfVisibleItems() > 1 ?
      Math.floor(e.detail.currentSlide / this.numberOfVisibleItems()) - 1 :
      e.detail.currentSlide - 1;

    if (this.$navigation.childNodes[childNodeIndex]) {
      this.$navigation.childNodes[childNodeIndex].classList.add('active');
    }
  }

  resetDotNavigation() {
    for (let i = 0, len = this.$navigation.childNodes.length; i < len; i += 1) {
      this.$navigation.childNodes[i].classList.remove('active');
    }

    this.$navigation.childNodes[0].classList.add('active');

    this.shouldNavigationBeHidden();
  }

  shouldNavigationBeHidden() {
    // Hide Navigation if there are to little slides to show
    if (this.$carouselItems.length <= this.numberOfVisibleItems()
      && this.navigationMediaQueryLarge.matches) {
      this.controlNavigationVisibility('hidden');
    } else {
      this.controlNavigationVisibility('visible');
    }
  }

  controlNavigationVisibility(visibility) {
    this.$navigation.setAttribute('style', `visibility: ${visibility}`);
    this.$el.querySelectorAll('.carousel__control').forEach(($el) => {
      $el.setAttribute('style', `visibility: ${visibility}`);
    });
  }

  numberOfSlides() {
    return this.$carouselItems.length / this.numberOfVisibleItems();
  }

  numberOfVisibleItems() {
    if (this.navigationMediaQueryMedium.matches) return 2;
    if (this.navigationMediaQueryLarge.matches) return this.options.maxSlidesPerPage;

    return 1;
  }

  reset() {
    this.$slider.destroy();
    this.initLory();
  }
}

document.querySelectorAll('.js-carousel').forEach(
  $el => new Carousel($el),
);



// WEBPACK FOOTER //
// ./src/components/molecules/carousel/carousel.js